import React, { useEffect, Fragment, useState } from "react";
import {
  Transition,
  Dialog,
  TransitionChild,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
  Menu,
  MenuButton,
  MenuItems,
  MenuItem,
} from "@headlessui/react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Button } from "../../Components/Button";
import {
  cancelAPIRequest,
  classNames,
  currencyFormat,
  generateArrayOfYears,
  getErrorMessages,
} from "../../Utils";
import { useTranslation } from "react-i18next";
import {
  useBusinessTransactionDispatch,
  useBusinessTransactionState,
} from "../../Context/businessTransaction/context";
import {
  clearBusinessTransaction,
  clearBusinessTransactionError,
  clearTaxDetail,
  clearUpdateBusiness,
  clearUpdateBusinessError,
  requestAddMainBusiness,
  requestDeleteCashTransaction,
  requestGetCashbookStats,
  requestGetTaxDetail,
  requestListBusiness,
  requestListBusinessTransaction,
  requestUpdateBusiness,
  setEbillingInitialData,
  useAuthDispatch,
  useAuthState,
  useEbillingDispatch,
} from "../../Context";
import { useLocation, useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { Pagination } from "../../Components/Pagination";
import { ModalConfirm } from "../../Components/ModalConfirm";
import DialogModal from "../../Components/DialogModal";
import { TAX_CATEGORIES } from "../../Constants";
import { TransactionFilter } from "../../Components/TransactionFilter";
import TableSkeleton from "../../Components/TableSkeleton";
import ErrorStateTable from "../../Components/ErrorStateTable";
import {
  ArrowSmRightIcon,
  ArrowSmUpIcon,
  TrashIcon,
  RefreshIcon,
  ExclamationIcon,
  PlusIcon,
  PencilAltIcon,
  ViewListIcon,
  ChevronDownIcon,
} from "@heroicons/react/outline";
import SwitchLayoutBanner from "../../Components/SwitchLayoutBanner";
import Select from "react-select";
import { ModalAlert } from "../../Components/ModalAlert";
import { Alert } from "../../Components/Alert";
import { CreditCardIcon } from "@heroicons/react/solid";
import { dateFilterOptions } from "../../Constants";
import EmptyBusiness from "../../Components/EmptyBusiness";
import { Modal } from "../../Components/Modal";
import FormLabel from "../../Components/FormLabel";
import {
  BUSINESS_ENTITY_TYPES,
  BUSINESS_TYPES_OPTIONS,
  isBusinessMainBlocked,
} from "../../Constants/business";

dayjs.extend(customParseFormat);
const years = generateArrayOfYears();

export const CashBook = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuthState();
  const [selectedBusiness, setSelectedBusiness] = useState({});
  const [page, setpage] = useState(1);
  const [showSalesOptions, setshowSalesOptions] = useState(false);
  const [showSMBInfo, setshowSMBInfo] = useState(false);
  const [showNoTaxModal, setshowNoTaxModal] = useState(false);
  const [showSMBDialog, setshowSMBDialog] = useState(false);
  const [showSMBPayDialog, setshowSMBPayDialog] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [transactionID, setTransactionID] = useState("");
  const [date, setDate] = useState(new Date());
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;
  const [createdAt, setcreatedAt] = useState({});
  const [selectedFilter, setSelectedFilter] = useState(dateFilterOptions[0]);
  const [showCashbookV2Banner, setShowCashbookV2Banner] = useState(true);

  const [submitted, setsubmitted] = useState(false);
  const [type, settype] = useState("PERSONAL");
  const [entityType, setentityType] = useState("");
  const [selectedTaxCategory, setselectedTaxCategory] = useState("");
  const [npwp, setnpwp] = useState("");
  const [selectedYearRegistered, setselectedYearRegistered] = useState("");
  const [typeError, settypeError] = useState(null);
  const [entityTypeError, setentityTypeError] = useState(null);
  const [taxCategoryError, settaxCategoryError] = useState(null);
  const [yearRegisteredError, setyearRegisteredError] = useState(null);
  const [npwpError, setnpwpError] = useState(null);
  const [showRequiredFormModal, setShowRequiredFormModal] = useState(false);
  const [showUpdateBusinessSuccessModal, setshowUpdateBusinessSuccessModal] =
    useState(false);
  const [showErrorModal, setshowErrorModal] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const businessIdParam = searchParams.get("id");

  const dispatch = useBusinessTransactionDispatch();
  const ebillingDispatch = useEbillingDispatch();
  const authDispatch = useAuthDispatch();

  const {
    request,
    cashbookStatsRequest,
    businesses,
    nextTokens,
    transactions,
    loading,
    error,
    updateBusiness,
    taxDetail,
    taxDetailLoading,
    taxDetailError,
    deleteLoading,
    submitError,
    deletedId,
    cashbookStats,
    cashbookStatsLoading,
    cashbookStatsError,
  } = useBusinessTransactionState();

  const {
    type: businessType,
    structure,
    taxNumber,
    taxCategory,
    yearRegistered,
  } = selectedBusiness || {};

  useEffect(() => {
    return () => {
      clearTaxDetail(dispatch);
      clearBusinessTransaction(dispatch);
      clearBusinessTransactionError(dispatch);
    };
  }, [dispatch]);

  useEffect(() => {
    if (user.id) {
      requestListBusiness(dispatch, { owner: user.id });
    }
  }, [dispatch, user.id]);

  useEffect(() => {
    // Function to set selected business
    const setSelectedBusinessLogic = async () => {
      if (businessIdParam) {
        if (businesses.length > 0) {
          const business = businesses.find(
            (item) => item.value === businessIdParam,
          );
          if (business) {
            setSelectedBusiness({
              ...business,
              label: business.name,
              value: business.id,
            });
          } else {
            // Handle if business is not found, select index 0
            setSelectedBusiness({
              ...businesses[0],
              label: businesses[0].name,
              value: businesses[0].id,
            });
          }
        } else {
          // Handle if businesses are empty, no business to select
        }
      } else if (user.mainBusiness) {
        // Set selectedBusiness directly from user.mainBusiness
        setSelectedBusiness({
          ...user.mainBusiness,
          label: user.mainBusiness.name,
          value: user.mainBusiness.id,
        });
      } else if (businesses.length > 0) {
        // Set selected business to the first item in the list
        // Prefer a healthy business: a RESTRICTED / PENDING_DELETION one must
        // not become the account-wide main business. Falls back to the first
        // entry when every business is blocked.
        const mainCandidate =
          businesses.find((business) => !isBusinessMainBlocked(business)) ||
          businesses[0];
        setSelectedBusiness({
          ...mainCandidate,
          label: mainCandidate.name,
          value: mainCandidate.id,
        });
        requestAddMainBusiness(authDispatch, {
          businessID: mainCandidate.id,
        });
      } else {
        // Handle if businesses are empty, no business to select
      }
    };

    setSelectedBusinessLogic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businesses, businessIdParam, user.mainBusiness]);

  useEffect(() => {
    if (updateBusiness?.id) {
      setSelectedBusiness({
        ...updateBusiness,
        value: updateBusiness.id,
        label: updateBusiness.name,
      });
      setshowSalesOptions(false);
      setShowRequiredFormModal(false);
      setshowUpdateBusinessSuccessModal(true);
      clearUpdateBusiness(dispatch);
      resetBusinessDetailRequiredForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, updateBusiness.id]);

  useEffect(() => {
    if ("totalIncome" in taxDetail) {
      if (taxDetail.totalTax === 0) {
        setshowSMBDialog(false);
        setshowNoTaxModal(true);
      }
      if (taxDetail.totalTax > 0) {
        setshowSMBPayDialog(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taxDetail.totalTax]);

  useEffect(() => {
    if (selectedBusiness?.value) {
      onLoad();
      onLoadCashbookStats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBusiness?.value]);

  useEffect(() => {
    if (!deletedId) {
      return;
    }
    setShowConfirmModal(false);
    setShowSuccessModal(true);
  }, [deletedId]);

  useEffect(() => {
    onLoadCashbookStats();
    if (selectedFilter.value === "MONTHLY") {
      setcreatedAt({
        between: [
          {
            type: "SALE",
            createdAt: dayjs(date).startOf("month").toISOString(),
          },
          {
            type: "SALE",
            createdAt: dayjs(date).endOf("month").toISOString(),
          },
        ],
      });
    }
    if (selectedFilter.value === "OTHER") {
      setcreatedAt({
        between: [
          {
            type: "SALE",
            createdAt: dayjs(startDate?.toISOString()).format("YYYY-MM-DD"),
          },
          {
            type: "SALE",
            createdAt: dayjs(endDate?.toISOString()).format("YYYY-MM-DD"),
          },
        ],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter.value, date, dateRange]);

  useEffect(() => {
    if (submitError) {
      setShowConfirmModal(false);
    }
  }, [submitError]);

  useEffect(() => {
    if (taxDetailError) {
      setshowErrorModal(true);
    }
  }, [taxDetailError]);

  useEffect(() => {
    if (submitted) {
      const validNpwp = Boolean(
        taxNumber || (npwp.length >= 15 && Number(npwp)),
      );
      const validBusinessType = Boolean(businessType || type);
      const validBusinessEntityType = Boolean(
        businessType === "PERSONAL" ||
        (businessType === "PERSONAL" && structure) ||
        entityType?.value,
      );
      const validTaxCategory = Boolean(
        taxCategory || selectedTaxCategory?.value,
      );
      const validYearRegistered = Boolean(
        yearRegistered || selectedYearRegistered?.value,
      );

      if (validNpwp) {
        setErrorMessage("npwp", "");
      } else {
        setErrorMessage("npwp", "Invalid NPWP. Enter 15-16 digits.");
      }

      if (validBusinessType) {
        setErrorMessage("type", "");
      } else {
        setErrorMessage("type", "Business Type name is required.");
      }

      if (validBusinessEntityType) {
        setErrorMessage("entityType", "");
      } else {
        setErrorMessage("entityType", "requiredBusinessEntityType");
      }

      if (validTaxCategory) {
        setErrorMessage("taxCategory", "");
      } else {
        setErrorMessage("taxCategory", "requiredAnnualRevenue");
      }

      if (validYearRegistered) {
        setErrorMessage("yearRegistered", "");
      } else {
        setErrorMessage("yearRegistered", "requiredNPWPYearRegistered");
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    submitted,
    type,
    entityType,
    selectedTaxCategory,
    npwp,
    selectedYearRegistered,
  ]);

  // Check if user prefers v2 layout
  useEffect(() => {
    const version = localStorage.getItem("cashbook_version");
    if (version === "v2") {
      navigate("/v2/cash-book");
    }
  }, [navigate]);

  const handleSwitchToNewLayout = () => {
    localStorage.setItem("cashbook_version", "v2");
    navigate("/v2/cash-book");
  };

  const onLoad = () => {
    if (request) {
      cancelAPIRequest(request);
    }
    if (submitError) {
      clearBusinessTransactionError(dispatch);
    }
    if (selectedBusiness?.value) {
      setpage(1);
      requestListBusinessTransaction(dispatch, {
        page: 1,
        limit: 10,
        businessID: selectedBusiness.value,
        createdAt,
      });
    }
  };

  const onNext = () => {
    const nextPage = page + 1;
    setpage(nextPage);
    if (nextTokens[nextPage]) {
      requestListBusinessTransaction(dispatch, {
        page: nextPage,
        limit: 10,
        businessID: selectedBusiness.value,
        nextToken: nextTokens[nextPage],
        createdAt,
      });
    }
  };

  const onPrev = () => {
    const prevPage = page - 1;
    setpage(prevPage);
    if (prevPage > 0) {
      requestListBusinessTransaction(dispatch, {
        page: prevPage,
        businessID: selectedBusiness.value,
        nextToken: nextTokens[prevPage],
        createdAt,
      });
    }
  };

  const onPageChange = (selectedPage) => {
    setpage(selectedPage);
    if (nextTokens[selectedPage] || selectedPage === 1) {
      requestListBusinessTransaction(dispatch, {
        page: selectedPage,
        businessID: selectedBusiness.value,
        nextToken: nextTokens[selectedPage],
        createdAt,
      });
    }
  };

  const onCreate = () => {
    navigate(`/cash-book/create?id=${selectedBusiness.value}`);
  };

  const onDelete = () => {
    requestDeleteCashTransaction(dispatch, {
      id: transactionID,
    });
  };

  const onNavigateToBusiness = () => {
    navigate("/business");
  };

  const onNavigateToEditBusiness = (id) => {
    if (id) {
      navigate(`/business/${id}`);
    }
  };

  const getMonthlyCashBookStats = () => {
    if (selectedBusiness?.value) {
      const startDate = dayjs(date).startOf("month").toISOString();
      const endDate = dayjs(date).endOf("month").toISOString();

      requestGetCashbookStats(dispatch, {
        businessID: selectedBusiness.value,
        startDate,
        endDate,
      });
    }
  };

  const getCustomDateCashBookStats = () => {
    if (selectedBusiness?.value && startDate && endDate) {
      const startOfDay = dayjs(startDate).startOf("day").toISOString();
      const endOfDay = dayjs(endDate).endOf("day").toISOString();

      requestGetCashbookStats(dispatch, {
        businessID: selectedBusiness.value,
        startDate: startOfDay,
        endDate: endOfDay,
      });
    }
  };

  const onLoadCashbookStats = () => {
    if (cashbookStatsRequest) {
      cancelAPIRequest(cashbookStatsRequest);
    }
    if (selectedFilter.value === "MONTHLY") {
      getMonthlyCashBookStats();
    }
    if (selectedFilter.value === "OTHER") {
      getCustomDateCashBookStats();
    }
  };

  const validateRequiredFormInput = () => {
    const validNpwp = Boolean(taxNumber || (npwp.length >= 15 && Number(npwp)));
    const validBusinessType = Boolean(businessType || type);
    const validBusinessEntityType = Boolean(
      businessType === "PERSONAL" ||
      (businessType === "BUSINESS" && structure) ||
      entityType?.value,
    );
    const validTaxCategory = Boolean(taxCategory || selectedTaxCategory?.value);
    const validYearRegistered = Boolean(
      yearRegistered || selectedYearRegistered?.value,
    );

    return (
      validNpwp &&
      validBusinessType &&
      validBusinessEntityType &&
      validTaxCategory &&
      validYearRegistered
    );
  };

  const onPayTax = () => {
    const currentYear = new Date().getFullYear();
    const MIN_YEARS_SMB_PERSONAL = 7;
    const MIN_YEARS_SMB_BUSINESS_PT = 3;
    const MIN_YEARS_SMB_BUSINESS_OTHER = 4;
    const selectedMonth = {
      label: dayjs(date?.toISOString()).format("MMMM"),
      value: dayjs(date?.toISOString()).format("M"),
    };
    const selectedYear = {
      label: dayjs(date?.toISOString()).format("YYYY"),
      value: parseInt(dayjs(date?.toISOString()).format("YYYY")),
    };

    const isRequiredFieldsMissing =
      !businessType ||
      (businessType === "BUSINESS" && !structure) ||
      !taxCategory ||
      !taxNumber ||
      !yearRegistered;

    if (error) {
      clearUpdateBusinessError(dispatch);
    }

    if (isRequiredFieldsMissing) {
      setShowRequiredFormModal(true);
      return;
    }

    const directNavigateToEbillingForm = () => {
      setEbillingInitialData(ebillingDispatch, {
        initialData: {
          businessID: selectedBusiness.id,
          startPeriod: selectedMonth.value,
          endPeriod: selectedMonth.value,
          year: selectedYear.value,
          npwp: selectedBusiness.taxNumber,
        },
      });
      navigate("/ebilling/create");
    };

    const personalEbillingNavigate = () => {
      setEbillingInitialData(ebillingDispatch, {
        initialData: {
          businessID: selectedBusiness.id,
          startPeriod: selectedMonth.value,
          endPeriod: selectedMonth.value,
          year: selectedYear.value,
          npwp: selectedBusiness.taxNumber,
        },
      });
      navigate("/ebilling/create?kap=411125&kjs=100");
    };

    const businessEbillingNavigate = () => {
      setEbillingInitialData(ebillingDispatch, {
        initialData: {
          businessID: selectedBusiness.id,
          startPeriod: selectedMonth.value,
          endPeriod: selectedMonth.value,
          year: selectedYear.value,
          npwp: selectedBusiness.taxNumber,
        },
      });
      navigate("/ebilling/create?kap=411126&kjs=100");
    };

    if (businessType === "PERSONAL") {
      if (taxCategory === "SMB_ZERO") {
        setshowSMBInfo(true);
      }
      if (taxCategory === "SMB") {
        if (currentYear - yearRegistered < MIN_YEARS_SMB_PERSONAL) {
          setshowSMBDialog(true);
        } else {
          personalEbillingNavigate();
        }
      } else if (taxCategory === "ENTERPRISE") {
        directNavigateToEbillingForm();
      }
    } else if (businessType === "BUSINESS") {
      if (taxCategory === "SMB" || taxCategory === "SMB_ZERO") {
        if (structure === "PT") {
          if (currentYear - yearRegistered < MIN_YEARS_SMB_BUSINESS_PT) {
            setshowSMBDialog(true);
          } else {
            businessEbillingNavigate();
          }
        } else if (
          ["CV", "FIRM", "COOPERATIVE", "BUMDES", "BUMDESBER"].includes(
            structure,
          )
        ) {
          if (currentYear - yearRegistered < MIN_YEARS_SMB_BUSINESS_OTHER) {
            setshowSMBDialog(true);
          } else {
            businessEbillingNavigate();
          }
        } else {
          businessEbillingNavigate();
        }
      } else {
        businessEbillingNavigate();
      }
    }
  };

  const setErrorMessage = (field, message) => {
    switch (field) {
      case "type":
        settypeError(message);
        break;
      case "entityType":
        setentityTypeError(message);
        break;
      case "taxCategory":
        settaxCategoryError(message);
        break;
      case "npwp":
        setnpwpError(message);
        break;
      case "yearRegistered":
        setyearRegisteredError(message);
        break;
      default:
        break;
    }
  };

  const resetBusinessDetailRequiredForm = () => {
    settype("");
    setentityType("");
    setselectedTaxCategory("");
    setnpwp("");
    setselectedYearRegistered("");

    setErrorMessage("npwp", "");
    setErrorMessage("type", "");
    setErrorMessage("entityType", "");
    setErrorMessage("taxCategory", "");
    setErrorMessage("yearRegistered", "");
  };

  const renderBusinessDetailRequiredForm = () => {
    return (
      <Modal
        title={t("payTaxRequiredFormTitle")}
        show={showRequiredFormModal}
        onClose={() => {
          resetBusinessDetailRequiredForm();
          setShowRequiredFormModal(false);
          setsubmitted(false);
        }}
        footer={
          <div className="p-4 flex justify-end items-center bg-gray-50 rounded-b-lg">
            <Button
              disabled={loading}
              loading={loading}
              onClick={(e) => {
                e.preventDefault();
                setsubmitted(true);
                if (!validateRequiredFormInput()) {
                  return;
                }

                const {
                  id,
                  name,
                  email,
                  phone,
                  address,
                  alwaysSync,
                  cashIncomeDebitAccountID,
                  cashIncomeCreditAccountID,
                  cashExpenseDebitAccountID,
                  cashExpenseCreditAccountID,
                  category,
                } = selectedBusiness || {};

                const input = {
                  id,
                  name,
                  email,
                  type: businessType || type,
                  structure: structure || entityType.value,
                  phone,
                  taxCategory: taxCategory || selectedTaxCategory.value,
                  address,
                  taxNumber: taxNumber || npwp,
                  yearRegistered:
                    yearRegistered || selectedYearRegistered.value,
                  category,
                  alwaysSync,
                  cashIncomeDebitAccountID,
                  cashIncomeCreditAccountID,
                  cashExpenseDebitAccountID,
                  cashExpenseCreditAccountID,
                };

                requestUpdateBusiness(dispatch, {
                  input,
                });
              }}
              className="w-24 shrink-0"
              title="Continue"
            />
          </div>
        }
      >
        <div className="flex flex-col gap-4 px-4 py-5">
          {error && (
            <Alert
              title="Error"
              type="error"
              message={error?.message || "error update business."}
              errors={error?.errors}
            />
          )}

          {!businessType && (
            <div>
              <FormLabel htmlFor="type" label={t("Business Type")} required />
              <select
                id="type"
                name="type"
                value={type}
                onChange={(event) => settype(event.target.value)}
                className={classNames(
                  typeError
                    ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                  "mt-1 block w-full text-sm rounded-md border bg-white py-2 px-3 shadow-sm",
                )}
              >
                {BUSINESS_TYPES_OPTIONS.map((businessType) => (
                  <option key={businessType.value} value={businessType.value}>
                    {t(businessType.label)}
                  </option>
                ))}
              </select>
              {typeError && (
                <div className="mt-1 text-red-600 text-sm">{t(typeError)}</div>
              )}
            </div>
          )}

          {!structure && businessType === "BUSINESS" && (
            <div>
              <FormLabel
                htmlFor="entityType"
                label={t("businessEntityType")}
                required
              />
              <Select
                name="entityType"
                className={classNames(
                  entityTypeError
                    ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                  "mt-1 text-sm",
                )}
                classNamePrefix="select2-selection"
                options={BUSINESS_ENTITY_TYPES}
                placeholder={t("businessEntityInputPlaceholder")}
                value={entityType}
                onChange={(value) => {
                  setentityType(value);
                }}
                isDisabled={businessType !== "BUSINESS"}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {entityTypeError && (
                <div className="mt-1 text-red-600 text-sm">
                  {t(entityTypeError)}
                </div>
              )}
            </div>
          )}

          {!taxCategory && (
            <div>
              <FormLabel
                htmlFor="taxCategory"
                label={t("Annual Revenue")}
                required
              />
              <Select
                name="taxCategory"
                options={TAX_CATEGORIES.map((category) => ({
                  value: category?.value,
                  label: t(category?.label),
                }))}
                value={selectedTaxCategory}
                onChange={(value) => {
                  setselectedTaxCategory(value);
                }}
                className={classNames(
                  taxCategoryError
                    ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                  "mt-1 text-sm",
                )}
                classNamePrefix="select2-selection"
                placeholder={t("Select Annual Revenue")}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {taxCategoryError && (
                <div className="mt-1 text-red-600 text-sm">
                  {t(taxCategoryError)}
                </div>
              )}
            </div>
          )}

          {!taxNumber && (
            <div>
              <FormLabel
                htmlFor="npwp"
                label={t("Tax Identification Number (NPWP)")}
                required
              />

              <NumericFormat
                type="text"
                name="npwp"
                id="npwp"
                allowLeadingZeros
                className={classNames(
                  npwpError
                    ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                  "mt-1 block w-full text-sm rounded-md shadow-sm",
                )}
                placeholder={t("Enter the tax identification number (NPWP)")}
                displayType="input"
                value={npwp || ""}
                onValueChange={(value) => {
                  setnpwp(value.value);
                }}
                isAllowed={({ value }) => value.length <= 16}
              />
              {npwpError && (
                <div className="mt-1 text-red-600 text-sm">{t(npwpError)}</div>
              )}
            </div>
          )}

          {!yearRegistered && (
            <div>
              <FormLabel
                htmlFor="year"
                label={t("npwpYearRegistered")}
                required
              />
              <Select
                name="year"
                className={classNames(
                  yearRegisteredError
                    ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
                  "mt-1 text-sm",
                )}
                classNamePrefix="select2-selection"
                options={years}
                placeholder={t("npwpYearRegisteredPlaceholder")}
                value={selectedYearRegistered}
                onChange={(value) => {
                  setselectedYearRegistered(value);
                }}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {yearRegisteredError && (
                <div className="mt-1 text-red-600 text-sm">
                  {t(yearRegisteredError)}
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
    );
  };

  const ErrorCard = () => {
    return (
      <div className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3">
        <div className="flex flex-col flex-1 min-w-0 gap-4">
          <div className="flex flex-row gap-4 items-center">
            <div className="p-1 flex items-center bg-red-100 border border-red-300 rounded-lg">
              <ExclamationIcon
                className="h-6 w-6 text-red-600"
                aria-hidden="true"
              />
            </div>
            <p className="text-sm text-gray-900">{t("Error")}</p>
          </div>
          <div className="flex justify-between text-base">
            <p>{t(getErrorMessages(cashbookStatsError))}</p>
            <button onClick={onLoadCashbookStats}>
              <RefreshIcon className="w-6 h-6 text-blue-600" />
            </button>
          </div>
        </div>
      </div>
    );
  };

  const TotalFinancial = () => {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {!cashbookStatsLoading && cashbookStatsError ? (
          <>
            <ErrorCard />
            <ErrorCard />
            <ErrorCard />
          </>
        ) : (
          <>
            <div className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3">
              <div className="flex flex-col flex-1 min-w-0 gap-4">
                <div className="flex flex-row gap-4 items-center">
                  <div className="p-1 flex items-center bg-green-100 border border-green-300 rounded-lg">
                    <ArrowSmUpIcon className="w-6 h-6 text-green-600 rotate-45" />
                  </div>
                  <p className="text-sm text-gray-600">{t("Total Income")}</p>
                </div>
                {cashbookStatsLoading ? (
                  <div className="animate-pulse w-32 h-6 bg-gray-300 rounded-md"></div>
                ) : (
                  <div className="text-base sm:text-lg font-medium">
                    <NumericFormat
                      displayType={"text"}
                      thousandSeparator={"."}
                      value={cashbookStats.total_income || 0}
                      decimalSeparator={","}
                      prefix={"Rp "}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3">
              <div className="flex flex-col flex-1 min-w-0 gap-4">
                <div className="flex flex-row gap-4 items-center">
                  <div className="p-1 flex items-center bg-red-100 border border-red-300 rounded-lg">
                    <ArrowSmRightIcon className="w-6 h-6 text-red-600 rotate-45" />
                  </div>
                  <p className="text-sm text-gray-600">{t("Total Expense")}</p>
                </div>
                {cashbookStatsLoading ? (
                  <div className="animate-pulse w-32 h-6 bg-gray-300 rounded-md"></div>
                ) : (
                  <div className="text-base sm:text-lg font-medium">
                    <NumericFormat
                      displayType={"text"}
                      thousandSeparator={"."}
                      value={cashbookStats.total_expense || 0}
                      decimalSeparator={","}
                      prefix={"Rp "}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3">
              <div className="flex flex-col flex-1 min-w-0 gap-4">
                <div className="flex flex-row gap-4 items-center">
                  <div className="p-1 flex items-center bg-blue-400 border border-blue-600 rounded-lg">
                    <CreditCardIcon className="w-6 h-6 text-white" />
                  </div>
                  <p className="text-sm text-gray-600">{t("Balance")}</p>
                </div>
                {cashbookStatsLoading ? (
                  <div className="animate-pulse w-32 h-6 bg-gray-300 rounded-md"></div>
                ) : (
                  <div className="text-base sm:text-lg font-medium">
                    <NumericFormat
                      displayType={"text"}
                      thousandSeparator={"."}
                      value={cashbookStats.balance || 0}
                      decimalSeparator={","}
                      prefix={"Rp "}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  const SalesOptions = () => {
    const [selectedSales, setselectedSales] = useState("");

    const handleChanges = (values) => {
      setselectedSales(values);
    };

    return (
      <Transition show={showSalesOptions}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setshowSalesOptions}
        >
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            />
          </TransitionChild>
          {/* Headless UI marks the backdrop aria-hidden, so the panel cannot
              live inside it. */}
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <TransitionChild
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          {t("Choose Annual Sales")}
                        </DialogTitle>
                        <div className="mt-2">
                          <legend className="sr-only">
                            {t("Type of annual sales")}
                          </legend>
                          <fieldset>
                            <div className="space-y-4">
                              {TAX_CATEGORIES.map((category) => (
                                <div
                                  key={category.value}
                                  className="flex items-center"
                                >
                                  <input
                                    id={category.value}
                                    name="notification-method"
                                    type="radio"
                                    className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300"
                                    defaultChecked={
                                      selectedBusiness.taxCategory ===
                                      category.value
                                    }
                                    onChange={() =>
                                      handleChanges(category.value)
                                    }
                                  />
                                  <label
                                    htmlFor={category.value}
                                    className="ml-3 block text-sm font-medium text-gray-700"
                                  >
                                    {t(category.label)}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className={classNames(
                        loading
                          ? "bg-gray-300 border-transparent cursor-not-allowed text-white"
                          : "bg-blue-600 hover:bg-blue-500",
                        "inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-auto",
                      )}
                      onClick={() => {
                        requestUpdateBusiness(dispatch, {
                          input: {
                            id: selectedBusiness.value,
                            taxCategory: selectedSales,
                          },
                        });
                      }}
                    >
                      {loading ? (
                        <svg
                          role="status"
                          className="text-white w-5 h-5 animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                      ) : (
                        <span>{t("Continue")}</span>
                      )}
                    </button>
                    <button
                      type="button"
                      className={classNames(
                        loading
                          ? "bg-gray-300 text-white border-transparent cursor-not-allowed"
                          : "bg-white text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
                        "mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm sm:mt-0 sm:w-auto",
                      )}
                      onClick={() => {
                        setshowSalesOptions(false);
                      }}
                    >
                      {t("Cancel")}
                    </button>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    );
  };

  const SMBModal = () => (
    <ModalConfirm
      open={showSMBInfo}
      setOpen={(open) => {
        setshowSMBInfo(false);
      }}
      title="No Obligation Yet"
      description="taxInfoModalSmbZero"
      type="SUCCESS"
      onConfirm={() => {
        setshowSMBInfo(false);
        clearTaxDetail(dispatch);
      }}
    />
  );

  const NoTaxModal = () => (
    <ModalConfirm
      open={showNoTaxModal}
      setOpen={(open) => {
        setshowNoTaxModal(open);
      }}
      title="No Obligation Yet"
      description="There is no tax obligation that must be paid."
      type="SUCCESS"
      onConfirm={() => {
        setshowNoTaxModal(false);
        clearTaxDetail(dispatch);
      }}
    />
  );

  const SMBDialog = () => (
    <DialogModal
      type="info"
      show={showSMBDialog}
      title="Pay Income Tax"
      body={t("taxInfoModalSmb")}
      confirmTitle="Continue"
      onClose={() => {
        setshowSMBDialog(false);
      }}
      onCancel={() => {
        setshowSMBDialog(false);
      }}
      onConfirm={() => {
        const month = dayjs(date?.toISOString());
        requestGetTaxDetail(dispatch, {
          businessID: selectedBusiness.value,
          startDate: month.startOf("month").toISOString(),
          endDate: month.endOf("month").toISOString(),
        });
      }}
    />
  );

  const SMBPayDialog = () => (
    <DialogModal
      type="info"
      show={showSMBPayDialog}
      title="Pay Income Tax"
      body={t("taxInfoModalSmbPay", {
        totalTax: currencyFormat(taxDetail.totalTax),
      })}
      onClose={() => {
        setshowSMBPayDialog(false);
        clearTaxDetail(dispatch);
      }}
      onCancel={() => {
        setshowSMBPayDialog(false);
        clearTaxDetail(dispatch);
      }}
      onConfirm={() => {
        setshowSMBPayDialog(false);
        const selectedMonth = {
          label: dayjs(date?.toISOString()).format("MMMM"),
          value: dayjs(date?.toISOString()).format("M"),
        };
        const selectedYear = {
          label: dayjs(date?.toISOString()).format("YYYY"),
          value: parseInt(dayjs(date?.toISOString()).format("YYYY")),
        };

        setEbillingInitialData(ebillingDispatch, {
          initialData: {
            name: selectedBusiness.name,
            businessID: selectedBusiness.id,
            startPeriod: selectedMonth.value,
            endPeriod: selectedMonth.value,
            year: selectedYear.value,
            npwp: selectedBusiness.taxNumber,
            total: taxDetail.totalTax,
          },
        });
        navigate("/ebilling/create?kap=411128&kjs=420");
      }}
    />
  );

  if (user.mainBusinessID || businesses.length > 0) {
    return (
      <div className="space-y-6">
        {showCashbookV2Banner && (
          <SwitchLayoutBanner
            labelKey="switchLayoutLabels.newCashbookLayout"
            onSwitch={handleSwitchToNewLayout}
            onDismiss={() => setShowCashbookV2Banner(false)}
            variant="dark"
            direction="forward"
          />
        )}
        {
          <ModalAlert
            open={showConfirmModal}
            setOpen={(open) => {
              setShowConfirmModal(open);
            }}
            title="Delete Transaction"
            description="Are you sure you want to delete this cashbook transaction?"
            confirmButtonText="Yes"
            cancelButtonText="Cancel"
            loadingButton={deleteLoading}
            disabledButton={deleteLoading}
            onConfirm={onDelete}
          />
        }
        {
          <ModalConfirm
            open={showSuccessModal}
            type="SUCCESS"
            setOpen={(open) => {
              setShowSuccessModal(open);
            }}
            title="Success"
            description="The cash book transaction has been successfully deleted"
          />
        }
        {
          <ModalConfirm
            open={showUpdateBusinessSuccessModal}
            setOpen={(open) => {
              setshowUpdateBusinessSuccessModal(open);
            }}
            title="Success"
            description="Your business has been updated."
            type="SUCCESS"
            onConfirm={() => {
              clearUpdateBusiness(dispatch);
              onPayTax();
            }}
          />
        }
        {taxDetailError && (
          <ModalConfirm
            open={showErrorModal}
            setOpen={(open) => {
              setshowErrorModal(open);
            }}
            title="Error"
            description={getErrorMessages(taxDetailError)}
            type="ALERT"
            onConfirm={() => clearTaxDetail(dispatch)}
          />
        )}
        <SalesOptions />
        <SMBModal />
        <NoTaxModal />
        <SMBDialog />
        <SMBPayDialog />
        {renderBusinessDetailRequiredForm()}

        <TotalFinancial />
        <TransactionFilter
          selectedBusiness={selectedBusiness}
          setSelectedBusiness={setSelectedBusiness}
          businesses={businesses}
          date={date}
          setDate={setDate}
          startDate={startDate}
          endDate={endDate}
          setDateRange={setDateRange}
          dateRange={dateRange}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          createdAt={createdAt}
          onLoad={onLoad}
          btnDisabled={taxDetailLoading}
          showAdditionalButton={selectedFilter.value !== "OTHER"}
          additionalButtonTitle="Pay Tax"
          additionalButtonColor="green"
          filterDate="range"
          onClick={onPayTax}
          loading={selectedBusiness.taxCategory === "SMB" && taxDetailLoading}
        >
          <div className="flex flex-col flex-wrap sm:flex-row gap-4">
            <Menu as="div" className="relative">
              <MenuButton className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                {t("Business")}
                <ChevronDownIcon className="w-5 h-5 ml-2" aria-hidden="true" />
              </MenuButton>

              <MenuItems className="absolute right-0 mt-2 w-48 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                <div className="py-1">
                  <MenuItem>
                    {({ focus }) => (
                      <button
                        onClick={() =>
                          onNavigateToEditBusiness(selectedBusiness.id)
                        }
                        className={`${
                          focus ? "bg-gray-100 text-gray-900" : "text-gray-700"
                        } flex items-center w-full px-4 py-2 text-sm`}
                        data-testid="edit-business"
                      >
                        <PencilAltIcon className="w-5 h-5 mr-3" />
                        {t("Edit Business")}
                      </button>
                    )}
                  </MenuItem>

                  <MenuItem>
                    {({ focus }) => (
                      <button
                        onClick={onNavigateToBusiness}
                        className={`${
                          focus ? "bg-gray-100 text-gray-900" : "text-gray-700"
                        } flex items-center w-full px-4 py-2 text-sm`}
                        data-testid="manage-business"
                      >
                        <ViewListIcon className="w-5 h-5 mr-3" />
                        {t("See All")}
                      </button>
                    )}
                  </MenuItem>
                </div>
              </MenuItems>
            </Menu>
            <div>
              <Button
                type="button"
                icon={PlusIcon}
                onClick={onCreate}
                title={t("Transaction")}
                className="w-full"
                data-testid="create-new-transaction"
              />
            </div>
          </div>
        </TransactionFilter>
        <div className="flex flex-col">
          <div className="overflow-x-auto -mx-4 sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full align-middle md:px-6 lg:px-8">
              <div className="overflow-hidden border border-gray-200 rounded-lg shadow-sm">
                {submitError && (
                  <div className="bg-white px-4 py-6 sm:px-6">
                    <Alert
                      title="Error"
                      type="error"
                      message={
                        submitError?.message ||
                        "submitError delete Transaction."
                      }
                      errors={submitError?.errors}
                    />
                  </div>
                )}
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("ID")}
                      </th>
                      <td className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Date")}
                      </td>
                      <td className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Information")}
                      </td>
                      <th className="px-4 py-2 font-medium text-sm text-right text-gray-900 whitespace-nowrap">
                        {t("Sale")}
                      </th>
                      <th className="px-4 py-2 font-medium text-sm text-right text-gray-900 whitespace-nowrap">
                        {t("Expense")}
                      </th>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Action")}
                      </th>
                    </tr>
                  </thead>
                  {loading ? (
                    <TableSkeleton rows={3} columns={6} />
                  ) : (
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {selectedBusiness && transactions.length > 0 ? (
                        transactions.map((transaction) => {
                          const shortId = transaction.id.substr(
                            transaction.id.length - 5,
                          );
                          return (
                            <tr key={transaction.id}>
                              <td className="px-4 py-2 font-medium text-sm text-gray-00 whitespace-nowrap ">
                                <a href={`/cash-book/${transaction.id}`}>
                                  {shortId}
                                </a>
                              </td>
                              <td className="px-4 py-2 font-medium text-sm text-gray-00 whitespace-nowrap ">
                                {dayjs(transaction.createdAt)
                                  .locale(i18n.language)
                                  .format("DD MMM YYYY")}
                              </td>
                              <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                {transaction.note}
                              </td>
                              <td className="px-4 py-2 text-sm text-right text-gray-700 whitespace-nowrap">
                                <NumericFormat
                                  displayType={"text"}
                                  value={transaction.income}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  prefix={"Rp"}
                                />
                              </td>
                              <td className="px-4 py-2 text-sm text-right text-gray-700 whitespace-nowrap">
                                <NumericFormat
                                  displayType={"text"}
                                  value={transaction.expense}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  prefix={"Rp"}
                                />
                              </td>
                              <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                <div className="flex flex-auto gap-2">
                                  <button
                                    onClick={() => {
                                      setShowConfirmModal(true);
                                      setTransactionID(transaction.id);
                                    }}
                                  >
                                    <TrashIcon className="h-5 w-5 text-red-500" />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <ErrorStateTable error={error} />
                      )}
                    </tbody>
                  )}
                </table>
                <Pagination
                  page={page}
                  onPrev={onPrev}
                  onNext={onNext}
                  onPageChange={onPageChange}
                  nextTokens={nextTokens}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return <EmptyBusiness loading={loading} />;
};
